<mat-dialog-content class="overflow-hidden">
<div class="dialog-container custom-scrollv2">
  <div class="dialog-container_title">Can’t Deactivate Item</div>
  <div class="dialog-container_box">
    <div class="dialog-container_box--delete py-2">
      <i class="far fa-trash-alt"></i>
    </div>
    <div class="mb-3 text-center">
      <span class="font_size_12">These items are avialable in the PO list.<br>It can not be deleted.</span>
    </div>
    <div class="dialog-container_box--list custom-scrollv2">
      <div class="sku-header" *ngFor="let item of data">
        <div class="sku-header_image">
          <img class="sku-header_image-inner" [src]="item?.imageUrl" alt="" />
        </div>
        <div class="sku-header_details">
            <div class="sku-header_title">{{item.vendorItemName}}</div>
            <span class="sku-header_chip">
                {{item.name}}
            </span>
        </div>
      </div>
    </div>
  </div>
  <div class="dialog-container_action">
    <app-button [buttonSize]="'action'" (click)="action()">Dismiss</app-button>
  </div>
</div>
</mat-dialog-content>